module.exports = __webpack_public_path__ + "img/armor-bracers.ab440cc3.svg";